import { View } from "react-native";
import {
  FileCheck2,
  FileText,
  Receipt,
  Wallet,
  type LucideIcon,
} from "lucide-react-native";
import { Dialog, DialogHeader, Row } from "@louise/moon-ui";
import { colors } from "@louise/moon-ui/theme/tokens";
import { EMBER } from "../../onboarding/theme";
import type { ManualPaymentKind } from "../screens/costs/suggested/CostsOverviewConceptScreen";

const PAYMENT_ENTRY_OPTIONS: {
  kind: ManualPaymentKind;
  label: string;
  description: string;
  icon: LucideIcon;
}[] = [
  {
    kind: "payment",
    label: "Payment",
    description: "A payment you made to a clinic, pharmacy, or lab.",
    icon: Wallet,
  },
  {
    kind: "claim",
    label: "Claim",
    description: "An insurance claim or reimbursement in progress.",
    icon: FileCheck2,
  },
  {
    kind: "receipt",
    label: "Receipt",
    description: "A receipt you want to keep with your cost records.",
    icon: Receipt,
  },
  {
    kind: "balance",
    label: "Balance",
    description: "A clinic balance or amount you still need to pay.",
    icon: FileText,
  },
];

type Props = {
  visible: boolean;
  onClose: () => void;
  onSelect: (kind: ManualPaymentKind) => void;
};

export default function PaymentEntryTypePicker({
  visible,
  onClose,
  onSelect,
}: Props) {
  return (
    <Dialog
      visible={visible}
      onClose={onClose}
      closeButton="with-background"
      containerStyle={{
        width: "90%",
        maxWidth: 430,
        maxHeight: "88%",
      }}
      contentStyle={{
        paddingTop: 24,
        paddingHorizontal: 16,
        paddingBottom: 16,
      }}
    >
      <DialogHeader
        title="What would you like to add?"
        subtitle="Choose a record type, then add the details or attach a document."
        style={{ paddingRight: 40, marginBottom: 16 }}
      />

      <View
        style={{
          overflow: "hidden",
          borderRadius: 16,
          borderWidth: 1,
          borderColor: colors.border,
        }}
      >
        {PAYMENT_ENTRY_OPTIONS.map(
          ({ kind, label, description, icon: Icon }, index) => (
            <Row
              key={kind}
              surface="plain"
              leading={
                <Icon size={18} color={colors.greyBrown} strokeWidth={1.8} />
              }
              leadingSize={28}
              title={label}
              subtitle={description}
              onPress={() => onSelect(kind)}
              chevron={false}
              accessibilityLabel={label}
              paddingHorizontal={12}
              paddingVertical={12}
              borderRadius={0}
              titleStyle={{
                fontSize: 14,
                lineHeight: 18,
                fontWeight: "600",
                color: EMBER.colors.text,
              }}
              subtitleStyle={{
                fontSize: 11,
                lineHeight: 16,
                color: EMBER.colors.textLight,
              }}
              style={{
                borderRadius: 0,
                borderTopWidth: index === 0 ? 0 : 1,
                borderTopColor: colors.border,
              }}
            />
          ),
        )}
      </View>
    </Dialog>
  );
}
